module.exports = __webpack_public_path__ + "static/media/deeplearning.bd5330f3.jpg";